import { render, staticRenderFns } from "./plat.vue?vue&type=template&id=6c52c228&scoped=true&"
import script from "./plat.vue?vue&type=script&lang=js&"
export * from "./plat.vue?vue&type=script&lang=js&"
import style0 from "./plat.vue?vue&type=style&index=0&id=6c52c228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c52c228",
  null
  
)

export default component.exports